

export const anonymousMenuItems = [


    {
        id: 1,
        label: 'Accueil',
        icon: '',
        withIcon: true,
        subItems:[],
        link: '/', 
        
    },

    {
        id: 2,
        label: 'Concept',
        link: '/concept-sacs-personnalisés',
        icon: '4',
     
    },
    
    // {
    //     id: 3,
    //     label: 'Tarifs',
    //     link: '/tarifs-sacs-personnalisés',
    //     icon: '4 ',
    // },
    {
        id: 4,
        label: 'Nos Produits',
        icon: '4',
        link: '/sac-personnalise',
    },
    {
        id: 5,
        label: 'Contact',
        icon: '4',
        link: '/contacter-nous',
    },

 

];

